/**
 *    My Request Accordion
 */

(function ($) {
  Drupal.behaviors.myRequestAccordion = {
    attach(context, settings) {
      const $items = $('.vb-my-request-accordion__item');

      /**
       * Add requested favorites to local storage for marking them in the favorite view
       */
      $('.vb-button--my-request-submit').on('click', function (event) {
        event.preventDefault();

        const target = $(this).data('target');

        const alreadyRequested = localStorage.getItem('favorites-already-requested') ? JSON.parse(localStorage.getItem('favorites-already-requested')) : [];

        $items.each(function (index, element) {
          const $el = $(this);
          const id = $el.attr('data-node-id');

          if ($.inArray(id, alreadyRequested) < 0) {
            alreadyRequested.push(id);
          }
        });

        localStorage.setItem('favorites-already-requested', JSON.stringify(alreadyRequested));

        $(target).click();
      });
    },
  };
}(jQuery));

// end of my-request-accordion.js
